import React from 'react';

const LogoutHeader = () => {
    return (
        <div>
            <h1>Logout</h1>
        </div>
    );
};

export default LogoutHeader;
